<script setup>
import { onBeforeUnmount, onMounted } from "vue";
import { dismissUpdate, startVersionWatcher, versionState } from "@/utils/appVersion";

let stopWatcher = () => {};

onMounted(() => {
  stopWatcher = startVersionWatcher();
});
onBeforeUnmount(() => stopWatcher());

// Solo se recarga la página: la sesión y las preferencias (localStorage) se conservan
const reload = () => window.location.reload();
</script>

<template>
  <el-dialog v-if="versionState.updateAvailable" :model-value="true" width="min(500px, 92vw)" :show-close="false"
    :lock-scroll="false" class="update-dialog" style="border-radius: 20px;" @close="dismissUpdate">
    <div class="update-dialog__content">
      <div class="update-dialog__header">
        <div class="title-text update-dialog__title">
          <font-awesome-icon icon="arrows-rotate" class="update-dialog__title-icon" />
          Nueva versión disponible
        </div>
        <button type="button" class="update-dialog__close" aria-label="Cerrar" @click="dismissUpdate">
          <font-awesome-icon icon="times" />
        </button>
      </div>
      <p class="update-dialog__message">Hay una versión nueva de ConnectUs.</p>
      <p class="update-dialog__secondary-message">
        Guarda lo que estés haciendo y recarga (Ctrl + F5, o Cmd + Shift + R en Mac) para usarla. Tu sesión se mantiene.
      </p>
      <div class="update-dialog__actions">
        <button type="button" class="btn btn_yellow px-4 update-dialog__button" @click="dismissUpdate">
          Más tarde
        </button>
        <button type="button" class="btn btn_darkpink px-4 update-dialog__button" @click="reload">
          Recargar
        </button>
      </div>
    </div>
  </el-dialog>
</template>

<style lang="scss" scoped>
.update-dialog__content {
  padding-bottom: 8px;
}

.update-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-top: 2px;
}

.update-dialog__title {
  align-items: center;
  color: $font-blue-color;
  display: flex;
  flex: 1;
  font-size: 28px;
  gap: 12px;
  line-height: 1.15;
  text-align: left;
}

.update-dialog__title-icon {
  width: 30px;
  min-width: 30px;
  font-size: 30px;
}

.update-dialog__close {
  background: none;
  border: 0;
  color: $font-blue-color;
  cursor: pointer;
  font-size: 22px;
  line-height: 1;
  padding: 0 4px;
}

.update-dialog__message {
  color: #1f2937;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.35;
  margin: 16px 0 6px;
}

.update-dialog__secondary-message {
  color: #6b7280;
  margin-bottom: 0;
}

.update-dialog__actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
}

.update-dialog__button {
  width: 40%;
}

@media (max-width: 767px) {
  .update-dialog__title {
    font-size: 24px;
  }

  .update-dialog__actions {
    flex-direction: column-reverse;
  }

  .update-dialog__button {
    width: 100%;
  }
}
</style>
